import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";

const ViewAnnouncement = () => {
  const { id } = useParams();
  const token = config.token;
  const [loading, setLoading] = useState(false);

  //----------------------------------------------- State Management -----------------------------------------------
  const [announcementData, setAnnouncementData] = useState({});

  //----------------------------------------------- Get / Read Announcement -----------------------------------------------R
  const fetchAnnouncementData = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}announcement/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            console.log(data.data);
            const responseData = data.data;

            // ---------------- date formation -----------
            // const options = { year: "numeric", month: "short", day: "2-digit" };

            // const serverDOB = await new Date(responseData.dob);
            // const formattedDOB = serverDOB.toLocaleDateString(undefined, options);

            // const serverJoinD = new Date(responseData.joining_date);
            // const formattedJoinD = serverJoinD.toLocaleDateString(undefined, options);

            await setAnnouncementData(responseData);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      fetchAnnouncementData(id);
    }
  }, [id]);

  return (
    <>
      <Breadcrumb
        txt="Manage Announcement"
        subpath={["View Announcements", "Announcement Details"]}
        url={["/viewannouncements"]}
      />

      <div className="col-xxl">
        <div className="card mb-4">
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body row g-3">
              <div className="col-lg-12">
                <div className="card academy-content shadow-none ">
                  <div className="card-header">
                    <h3 className="card-action-title mb-2">
                      {announcementData.title}
                    </h3>
                    <i className="mr-2 mdi mdi-calendar"></i>
                    <span className="mr-5">
                      {announcementData &&
                        announcementData.datetime &&
                        announcementData.datetime.slice(0, 10)}
                    </span>
                    <i className="mr-2 mdi mdi-clock-time-four-outline"></i>
                    <span className="mr-5">
                      {announcementData &&
                        announcementData.datetime &&
                        announcementData.datetime.slice(11, 18)}
                    </span>
                    <span className="mt-2">
                      Announcement For {announcementData.announcement_for}{" "}
                      {" ( "}
                      {announcementData.announcement_for === "section"
                        ? announcementData.class +
                          " - " +
                          announcementData.section
                        : announcementData.announcement_for === "class"
                        ? announcementData.class
                        : announcementData.announcement_for === "course"
                        ? announcementData.course_name
                        : announcementData.announcement_for === "teacher"
                        ? announcementData.fname + " " + announcementData.lname
                        : announcementData.announcement_for === "student"
                        ? announcementData.first_name +
                          " " +
                          announcementData.last_name
                        : ""}
                      {" ) "}{" "}
                    </span>
                  </div>
                  <hr className="m-1" />
                  <div className="card-body">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: announcementData.content,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewAnnouncement;
